import React, { useState, useCallback, useEffect } from "react";
import styled from "styled-components";
import logger from "utils/logger";
import data from "services/data";
import InputGroup from "./inputGroup";
import FormTitle from "./formTitle";
import Button from "./button";
import notifier from "utils/notifier";

const StyledLogin = styled.div`
  width: 100%;
  padding: 35px 15px;

  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 25px;
`;

const userFormKey = "userForm";

const StyledButtonGroup = styled.div`
  display: flex;
  column-gap: 10px;
  justify-content: space-around;
  width: 100%;
`;

const Login = ({ onLogin }) => {
  const [form, setForm] = useState({
    userName: "",
    password: "",
  });

  const [errorMessage, setErrorMesage] = useState("");

  const handleValueChange = useCallback(
    (name, value) => {
      const copy = { ...form };
      copy[name] = value;
      setForm(copy);
    },
    [form]
  );

  const handleFormStoreClear = useCallback(() => {
    setForm({
      userName: "",
      password: "",
    });
    localStorage.removeItem(userFormKey);
  }, []);

  const handleLogin = useCallback(async () => {
    const { userName, password } = form;
    try {
      const user = await data.getAuthorization(userName, password);
      logger.log("获取到用户：", user, form);
      // 用户表单存入本地
      localStorage.setItem(userFormKey, JSON.stringify(form));
      onLogin && onLogin(user);
    } catch (error) {
      logger.log(error.message);
      notifier.error(error.message)
      // setErrorMesage(error.message);
    }
  }, [form, onLogin]);

  useEffect(() => {
    const userForm = JSON.parse(localStorage.getItem(userFormKey));
    if (userForm) {
      const { userName, password } = userForm;
      setForm({
        userName,
        password,
      });
    }
  }, []);

  return (
    <StyledLogin
      onKeyUp={(e) => {
        e.preventDefault();
        //阻止事件进一步传播
        e.stopPropagation();
        switch (e.keyCode) {
          //回车 提交
          case 13:
            handleLogin();
            break;
          default:
            return;
        }
      }}
    >
      <FormTitle>登录</FormTitle>
      <InputGroup
        label="用户名"
        type="text"
        name="userName"
        value={form.userName}
        onChange={handleValueChange}
        placeholder="请输入用户名"
      />
      <InputGroup
        label="密 码"
        type="password"
        name="password"
        value={form.password}
        onChange={handleValueChange}
        placeholder="请输入密码"
      />
      <StyledButtonGroup>
        <Button onClick={handleFormStoreClear} title="清空存储的表单">
          清除
        </Button>
        <Button message={errorMessage} onClick={handleLogin}>
          登录
        </Button>
      </StyledButtonGroup>
    </StyledLogin>
  );
};

export default Login;
